// Libraries
import React from 'react'
import PropTypes from 'prop-types'

// Component
export const IconGoogle = ({ width, height, onClick }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 59 59"
      onClick={onClick}
      style={{ cursor: 'pointer' }}
    >
      <circle className="a" fill="#2f529f" cx="29.5" cy="29.5" r="29.5" />
      <path
        className="b"
        fill="#fff"
        d="M14.858,3.522h1.937V.149A25.007,25.007,0,0,0,13.973,0c-2.792,0-4.7,1.756-4.7,4.984V7.955H6.187v3.771H9.268v9.487h3.778V11.726H16l.469-3.771H13.045v-2.6c0-1.09.294-1.836,1.813-1.836Z"
        transform="translate(17.271 19.445)"
      />
    </svg>
  )
}

IconGoogle.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  onClick: PropTypes.func,
}

IconGoogle.defaultProps = {
  width: '45px',
  height: '45px',
  onClick: () => {},
}

export default IconGoogle
